<template>
  <div class="bg_gray" style="overflow:hidden;">
    <Header navTitle="账号资料" navPath="/mobile/center"></Header>
    <!-- 登录信息 -->
    <van-cell-group class="part">
      <van-cell title-style="font-weight:bold" title="登录信息" />
      <van-field v-if="account === origin_username"
        v-model="account"
        is-link
        readonly
        label="账号"
        placeholder="点击修改账号"
        @click="editAccount"
      />
      <van-field v-else
        v-model="account"
        readonly
        label="账号"
        placeholder="点击修改账号"
      />
      <van-field
        v-model="tel"
        is-link
        readonly
        label="手机号"
        placeholder="点击修改手机号"
        @click="editTel"
      />
      <van-field
        v-model="email"
        is-link
        readonly
        label="邮箱"
        placeholder="点击修改邮箱"
        @click="editMail"
      />
      <van-cell v-if="!isEditMail && email && !email_verified" title-style="color:#999">
        <template #title>
          邮件已发送，未激活，请24小时内验证。<a href="#" @click="sendMail()">重新发送</a>
        </template>
      </van-cell>
      <van-cell title-style="color:#646566" title="修改密码" is-link @click="showResetPwdModal" />
    </van-cell-group>

    <!-- 个人信息 -->
    <van-cell-group class="part">
      <van-cell title-style="font-weight:bold" title="个人信息" is-link @click="editInfo" />
      <van-field
        v-model="realname"
        readonly
        label="姓名"
        placeholder="-"
      />
      <van-field
        v-model="job_identity"
        readonly
        label="职业"
        placeholder="-"
      />
      <van-field
        v-model="work_place"
        readonly
        label="单位/学校"
        placeholder="-"
      />
      <van-field
        v-model="job_name"
        readonly
        label="岗位/专业"
        placeholder="-"
      />
    </van-cell-group>

    <!-- 账号绑定 -->
    <van-cell-group class="part">
      <van-cell title-style="font-weight:bold" title="账号绑定" />
      <van-field v-if="qq.account_name"
        v-model="qq.account_name"
        readonly
        label="QQ"
      >
        <template #button>
          <van-button size="small" type="primary" @click="unBindThirdParty('qq')">解除绑定</van-button>
        </template>
      </van-field>
      <van-field v-else
        v-model="qq.account_name"
        is-link
        readonly
        label="QQ"
        placeholder="点击绑定"
        @click="bindThirdParty('qq')"
      />
      <van-field v-if="false"
        v-model="weixin.account_name"
        readonly
        label="微信"
      >
        <template #button>
          <van-button size="small" type="primary" @click="unBindThirdParty('weixin')">解除绑定</van-button>
        </template>
      </van-field>
      <van-field v-if="false"
        v-model="weixin.account_name"
        is-link
        readonly
        label="微信"
        placeholder="点击绑定"
        @click="bindThirdParty('weixin')"
      />
      <van-field v-if="weibo.account_name"
        v-model="weibo.account_name"
        readonly
        label="新浪微博"
      >
        <template #button>
          <van-button size="small" type="primary" @click="unBindThirdParty('weibo')">解除绑定</van-button>
        </template>
      </van-field>
      <van-field v-else
        v-model="weibo.account_name"
        is-link
        readonly
        label="新浪微博"
        placeholder="点击绑定"
        @click="bindThirdParty('weibo')"
      />
      <van-field v-if="baidu.account_name"
        v-model="baidu.account_name"
        readonly
        label="百度"
      >
        <template #button>
          <van-button size="small" type="primary" @click="unBindThirdParty('baidu')">解除绑定</van-button>
        </template>
      </van-field>
      <van-field v-else
        v-model="baidu.account_name"
        is-link
        readonly
        label="百度"
        placeholder="点击绑定"
        @click="bindThirdParty('baidu')"
      />
      <van-field v-if="github.account_name"
        v-model="github.account_name"
        readonly
        label="GitHub"
      >
        <template #button>
          <van-button size="small" type="primary" @click="unBindThirdParty('github')">解除绑定</van-button>
        </template>
      </van-field>
      <van-field
        v-model="github.account_name"
        is-link
        readonly
        label="GitHub"
        placeholder="点击绑定"
        @click="bindThirdParty('github')"
      />
    </van-cell-group>

    <!-- 弹出框 -->
    <van-popup v-model:show="isShowPop" position="right" :style="{ width: '100%', height: '100%' }" class="bg_gray">
      <!-- 修改账号 -->
      <div v-if="isEditAccount">
        <van-nav-bar z-index="10" left-arrow title="账号资料" @click-left="cancel_edit('accountForm')"></van-nav-bar>
        <van-form ref="accountForm">
          <van-cell-group>
            <van-field
              v-model="form.account"
              name="account"
              label="账号"
              placeholder="请输入账号"
              :rules="rules.account"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" @click="submitForm('accountForm')">
              保存
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 修改手机号 -->
      <div v-if="editCellPhoneModal.visible">
        <van-nav-bar z-index="10" left-arrow title="修改手机号" @click-left="closeEditPhoneModal"></van-nav-bar>
        <van-notice-bar v-if="editCellPhoneModal.error" background="#fef0f0" color="#f56c6c">{{ editCellPhoneModal.error }}。</van-notice-bar>
        <van-form ref="editCellPhoneForm">
          <van-cell-group>
            <van-field
              v-model="editCellPhoneModal.form.addtel"
              name="addtel"
              label="手机号"
              placeholder="CN+86"
              :rules="rules.addtel"
            />
            <van-field v-if="!editCellPhoneModal.isVerify"
              v-model="editCellPhoneModal.form.yzm"
              name="yzm"
              center
              clearable
              label="验证码"
              placeholder="请输入短信验证码"
              :rules="rules.yzm"
            >
              <template #button>
                <van-button size="small" type="primary" v-if="!editCellPhoneModal.isGetYzm" @click="getEditSms()">获取验证码</van-button>
                <van-button size="small" type="primary" disabled v-else>{{ editCellPhoneModal.countdown }}</van-button>
              </template>
            </van-field>


            <!-- 校验 -->
            <van-field v-else>
              <template #input>
                <div style="width:100%;">
                  <SliderVerify ref="sliderVerify" @result="getEditPhoneResult"></SliderVerify>
                </div>
              </template>
            </van-field>

            <van-field label="序列号" v-if="editCellPhoneModal.form.yzm_serial">
              <template #input> {{ editCellPhoneModal.form.yzm_serial }}</template>
            </van-field>

          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" @click="submitEditPhoneForm">
              保存
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 修改邮箱 -->
      <div v-if="isEditMail">
        <van-nav-bar z-index="10" left-arrow title="修改邮箱" @click-left="cancel_edit('mailForm')"></van-nav-bar>
        <van-form ref="mailForm">
          <van-cell-group>
            <van-field
              v-model="form.email"
              name="email"
              label="邮箱"
              placeholder="请输入邮箱"
              :rules="rules.email"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" @click="submitForm('mailForm')">
              保存
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 修改密码 -->
      <div v-if="resetModalVisible">
        <van-nav-bar z-index="10" left-arrow title="修改密码" @click-left="closeResetPwdModal"></van-nav-bar>
        <ResetPwd v-model:visible="resetModalVisible" @closePwdModal="closeResetPwdModal"></ResetPwd>
      </div>
      <!-- 修改个人信息 -->
      <div v-if="isEditInfo">
        <van-nav-bar z-index="10" left-arrow title="个人信息" @click-left="cancel_edit('infoForm')"></van-nav-bar>
        <van-form ref="infoForm">
          <van-cell-group>
            <van-field
              v-model="form.realname"
              name="realname"
              :formatter="formatter1"
              label="姓名"
              placeholder="请输入姓名"
              :rules="rules.realname"
            />
            <van-field name="job" label="职业">
              <template #input>
                <van-radio-group v-model="form.job" direction="horizontal">
                  <van-radio name="office">职员</van-radio>
                  <van-radio name="student">学生</van-radio>
                  <van-radio name="teacher">教师</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="form.work_place"
              name="work_place"
              :formatter="formatter1"
              label="单位/学校"
              placeholder="请输入单位/学校"
              :rules="rules.work_place"
            />
            <van-field
              v-model="form.job_name"
              name="job_name"
              :formatter="formatter1"
              label="岗位/专业"
              placeholder="请输入岗位/专业"
              :rules="rules.job_name"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit" @click="submitForm('infoForm')">
              保存
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import ResetPwd from 'components/mobile/common/ResetPwd'
  import SliderVerify from 'components/mobile/common/SliderVerify'
  import { showConfirmMessageBox, showMessage } from 'api/base/mobile/message'
  import { GetUserState, userBindThirdParty, userUnBindThirdParty, AddCellPhone, sendUserEmail, getThirdRedirectUri, getDomainSite } from 'api/user/auth/login'
  import { checkEmail, checkUserName, checkPhone } from 'utils/mobile/common'
  import { updateUserInfo, addSystemUser, GetUserInfo, mobileCheckUserInfoExist } from 'api/user/user/user'
  import { checkPhoneExist, SendSms, RegisterUser } from 'api/user/auth/register'
  export default {
    components: {
      Header,
      ResetPwd,
      SliderVerify,
    },
    data() {
      let that = this;
      let checkUserNameExistRule = (value, rule) => {
        if (!value || value === that.account) return true;
        let data = {"username": value, "site_id": 1}
        return mobileCheckUserInfoExist(data, "账号")
      }

      let checkPhoneExistRule = (value, rule) => {
        if (!value || value === that.tel) return '请填写新的手机号码';

        return new Promise(resolve => {
          checkPhoneExist(value).then((res) => {
            if (!res.result) {
              resolve(true)
            } else {
              resolve('手机号码已经被注册')
            }
          }).catch(err => {
            resolve('服务异常，请稍后再试')
          });
        })
      }

      let checkUserEmailExistRule = (value, rule) => {
        if (!value || value === that.email) return '请填写新的邮箱地址';
        let data = {"email": value, "site_id": 1}
        return mobileCheckUserInfoExist(data, "邮箱")
      }

      let checkInput = (value, rule) => {
        return new Promise(resolve => {
          if (value.length > 50) {
            resolve('字符长度限制在1到50个字符以内')
          } else {
            resolve(true)
          }
        })
      }

      let checkInputLengthRule = (value, rule) => {
        console.log(value)
        if(value.length >= 50){
          return '字符长度限制在1到50个字符以内';
        }
        let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconRule2.test(value)){
          return "不能包含表情符号"
        }
        return true;

      }

      return {
        resetModalVisible: false,
        isShowPop: false,
        loading: false,
        isEditAccount: false,
        isEditTel: false,
        isEditMail: false,
        isEditInfo: false,
        user_id: '',
        account: '',
        origin_username: '',
        tel: '',
        email: '',
        realname: '',
        job_identity: '',
        job: '',
        work_place: '',
        job_name: '',
        email_verified: '',
        qq: {},
        weixin: {},
        weibo: {},
        baidu: {},
        github: {},
        form: {
          account: '',
          tel: '',
          email: '',
          job: '',
          work_place: '',
          job_name: '',
          realname: '',
        },
        editCellPhoneModal: {
          error: '',
          visible: false,
          isGetYzm: false,
          isVerify: false,
          countdown: '等待 60 s',
          form: {
            addtel: '',
            yzm: '',
            yzm_serial: '',
            verify: '',
            user_id: ''
          }
        },
        domainSite: 'https://www.fnedu.com',
        rules: {
          account: [
            { required: true, message: '请填写账号', trigger: 'onBlur' },
            { required: true, validator: checkUserName, trigger: 'onBlur' },
            { required: true, validator: checkUserNameExistRule, trigger: 'onBlur' }
          ],
          job_name: [
            { required: true, message: '必填项', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          work_place: [
            { required: true, message: '必填项', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          addtel: [
            { required: true, validator: checkPhone, message: '请填写手机号' },
            { required: true, validator: checkPhoneExistRule, trigger: 'onBlur' }
          ],
          email: [
            { required: true, message: '请填写邮箱', trigger: 'onBlur' },
            { min: 1, max: 250, message: '邮箱长度在1到250个字符内', trigger: 'onBlur' },
            { required: true, validator: checkEmail, trigger: 'onBlur' },
            { required: true, validator: checkUserEmailExistRule, trigger: 'onBlur' }
          ],
          realname: [
            { required: true, message: '必填项', trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ]
        }
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.setUserInfo();
      window.resetUserInfo = this.setUserInfo;
      window.showLoginMessage = this.showBindMessage;
      this.load_domain_site()
    },
    methods: {
      formatter1(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
      },
      closeResetPwdModal() {
        this.isShowPop = false
        this.resetModalVisible = false;
      },
      showResetPwdModal() {
        this.isShowPop = true
        this.resetModalVisible = true;
      },
      load_domain_site() {
        getDomainSite().then(res => {
          if(res.code == 0){
            this.domainSite = res.domain_site
          }
        })
      },
      cancel_edit(option) {
        this.isShowPop = false;
        switch(option){
          case 'accountForm': {
            this.isEditAccount = !this.isEditAccount;
            this.$refs[option].resetValidation();
          } break;
          case 'mailForm': {
            this.isEditMail = !this.isEditMail;
            this.$refs[option].resetValidation();
          } break;
          case 'infoForm': {
            this.isEditInfo = !this.isEditInfo;
            this.$refs[option].resetValidation();
          } break;
          default: {
              console.log('unknown command');
          } break;
        }
      },
      editAccount() {
        let msg = "账号名称只可以修改一次，确认修改吗？"
        showConfirmMessageBox(msg).then(() => {
          this.isShowPop = true;

          this.isEditAccount = !this.isEditAccount;
          this.form.account = this.account;
        }).catch(res => {})
      },

      editTel() {
        this.isShowPop = true;
        this.editCellPhoneModal.visible = true;
      },

      editMail() {
        this.isShowPop = true;
        this.isEditMail = !this.isEditMail;
        this.form.email = this.email;
      },

      editInfo() {
        this.isShowPop = true;
        this.isEditInfo = !this.isEditInfo;
        this.form.job = this.job;
        if (!this.form.job) {
          this.form.job = 'office'
        }
        this.form.job_name = this.job_name;
        this.form.work_place = this.work_place
        this.form.realname = this.realname;
      },

      updateUserInfoMethod(data) {
        updateUserInfo(this.user_id, data)
          .then((res) => {
            this.loading = false;
            if (res.result === 0) {
              this.$router.go(0);
            } else {
              showMessage(res.msg)
            }
          }).catch((err) => {
          this.loading = false;
          showMessage('服务异常，请稍后再试')
//          showMessage('您的输入有误，请刷新页面重新输入(特殊字符请勿输入)')
        })
      },

      sendMail() {
        sendUserEmail().then((res) => {
          if (res.result === 0) {
            showMessage('已经发送，请验证')
          } else {
            showMessage(res.msg)
          }
        }).catch((err) => {
          showMessage('服务异常，请稍后再试')
        })
      },
      submitForm(formName) {
          this.$refs[formName].validate().then(() => {
              switch(formName){
                case 'accountForm': {
                  this.updateUserInfoMethod({"username": this.form.account});
                } break;
                case 'mailForm': {
                  this.loading = true;
                  this.updateUserInfoMethod({"email": this.form.email});
                } break;
                case 'infoForm': {
                  this.updateUserInfoMethod({"realname": this.form.realname, "job": this.form.job, "job_name": this.form.job_name, "work_place": this.form.work_place});
                } break;
                default: {
                    console.log('unknown command');
                } break;
              }
          }).catch(err=>{

          });
      },

      getEditSms() {
        this.$refs.editCellPhoneForm.validate('addtel').then(()=>{
          this.editCellPhoneModal.isVerify = true;
        }).catch(err=>{})
      },
      getEditPhoneStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.editCellPhoneModal.form.verify = 'success';
        } else {
          this.editCellPhoneModal.form.verify = '';
        }
      },
      getEditPhoneResult(val) {
        this.getEditPhoneStatus(val)
        if(val === 'success') {
          // 校验成功
          this.editCellPhoneModal.isVerify = false;
          SendSms(this.editCellPhoneModal.form.addtel).then((res) => {
            if (!res.result){
              this.editCellPhoneModal.form.yzm_serial = res.serial;
              this.getAddPhoneYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getAddPhoneYzm(surplus_time) {
        // 展示等待时间
        this.editCellPhoneModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.editCellPhoneModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.editCellPhoneModal.isGetYzm = false;
            this.editCellPhoneModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      submitEditPhoneForm() {
        let that = this;
        this.$refs.editCellPhoneForm.validate().then(() => {

          AddCellPhone(this.editCellPhoneModal.form)
            .then((res) => {
              if (!res.result) {
                this.$router.go(0);
              } else {
                this.editCellPhoneModal.error = res.msg;
              }
            }).catch((err) => {
              showMessage('服务异常，请稍后再试')
          })

        }).catch(err=>{
          return false
        });
      },
      closeEditPhoneModal() {
        this.isShowPop = false;
        this.$refs.editCellPhoneForm.resetValidation();
        this.editCellPhoneModal.visible = false;
        this.editCellPhoneModal.error = '';
      },

      bindThirdParty(type) {
        if(type == 'qq'){
          // QC.Login.showPopup({
          //   appId: '101196615',
          //   // redirectURI: 'https://www.fnedu.com/mobile/login_success/qq-oauth2/qq-callback/?user_id=' + this.user_id
          //   redirectURI: 'https://www.fnedu.com/mobile/login_success/qq-oauth2/qq-callback/?user_id=' + this.user_id
          // })
          var redirect_uri = this.domainSite + '/mobile/login_success/qq-oauth2/qq-callback?user_id=' + this.user_id
          var url = 'https://graph.qq.com/oauth2.0/authorize?client_id=101196615&response_type=token&redirect_uri=' + encodeURIComponent(redirect_uri);
          location.href = url
        }
        else {
          userBindThirdParty(this.user_id, type, 'mobile')
        }
        // userBindThirdParty(this.user_id, type)
      },

      unBindThirdParty(type) {
        let msg = "确定要解除绑定吗？"
        let that = this;
        showConfirmMessageBox(msg).then(() => {
          userUnBindThirdParty(that.user_id, type).then((res) => {
            if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                this.$emit('update:loginVisible', true);
                return false;
            }
            showMessage('解除绑定成功')
            that.setUserInfo();
          }).catch((res) => {})
        }).catch(res => {})
      },

      setUserInfo() {
        let that = this;
        GetUserState({"email_status": true})
          .then((res) => {
            if (res.id) {
              that.user_id = res.id;
              that.editCellPhoneModal.form.user_id = res.id;
              that.account = res.username;
              that.tel = res.cellphone;
              that.origin_username = res.origin_username;
              that.realname = res.realname
              that.job = res.job;
              that.job_identity = res.job_identity;
              that.work_place = res.work_place;
              that.job_name = res.job_name;
              that.email = res.email;
              that.email_verified = res.email_verified;
              that.qq = res.qq ? res.qq : {account_name: ''};
              that.weixin = res.weixin ? res.weixin : {account_name: ''};
              that.weibo = res.weibo ? res.weibo : {account_name: ''};
              that.baidu = res.baidu ? res.baidu : {account_name: ''};
              that.github = res.github ? res.github : {account_name: ''};
            }
          });
      },
      showBindMessage(msg) {
        showMessage(msg)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .part {
    margin-bottom:15px;
    :deep(.edit_btns) {
      .el-form-item__content {
        margin-left:20px !important;
      }
    }
    :deep(.el-form-item) {
      .el-form-item__content {
        min-width:0;
        > span {
          display:block;
          white-space: nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          &.tip {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            position: relative;
            top: -2px;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .get_yzm {
    position:relative;
    .el-button, > span {
      position:absolute;
      right:10px;
      top:2px;
      font-size:12px;
    }
  }
</style>
